<script lang="ts" setup>
import CButton from '@lib/components/CButton/CButton.vue'
import useThemeVars from '@lib/composables/useThemeVars'

interface NavItem {
  name: string
  text: string
  activeRoutes?: string[]
  params?: Record<string, string | number>
}

interface Props {
  navItems: NavItem[]
  activeRouteName: string
}

const props = withDefaults(defineProps<Props>(), {
  navItems: () => [],
})

const emit = defineEmits<{
  (e: 'open', props: { name: string; params?: NavItem['params'] }): void
}>()

const isRouteActive = (linkRouteName: string, activeRoutes?: string[]): boolean =>
  props.activeRouteName === linkRouteName || !!(activeRoutes?.length && activeRoutes.includes(props.activeRouteName))

const themeVars = useThemeVars()
</script>

<template>
  <div class="c-secondary-nav">
    <div class="c-secondary-nav__nav-items">
      <CButton
        v-for="({ name, text, activeRoutes, params }, index) in navItems"
        :key="index"
        class="c-secondary-nav__button"
        :style="
          isRouteActive(name, activeRoutes)
            ? {
                '--n-color': themeVars.primary5,
                '--n-color-pressed': themeVars.primary5,
                '--n-color-focus': themeVars.primary5,
                '--n-color-hover': themeVars.primary5,
                '--n-border': `1px solid ${themeVars.primary}`,
              }
            : {}
        "
        @click="emit('open', { name, params })"
      >
        {{ text }}
      </CButton>
    </div>

    <div class="c-secondary-nav__slot">
      <slot name="right" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.c-secondary-nav {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.c-secondary-nav__nav-items {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
}
</style>
